import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AddressModel } from 'src/app/modules/shared/model/addressModel.model';
import { APOEntityType } from 'src/app/repo/contact-process-type.repo';
import { DataSourceFlag, FlagEnum } from 'src/app/repo/enum.repo';
import { ApoSuggestion } from '../../models/apoSuggestion.model';
import { APOSuggestionData } from '../../models/ApoSuggestionData.model';
import { APOSearchService } from '../../services/aposearch-service.service';
import { convertAddressModeltoRefAddressModel, convertRefAddressModeltoAddressModel, getAddressDescription } from '../../util/apo.util';

@Component({
  selector: 'apo-address-card',
  templateUrl: './address-card.component.html',
  styleUrls: ['./address-card.component.less']
})
export class AddressCardComponent implements OnInit, OnDestroy {

  @Input() address: AddressModel;
  @Input() sourceFlag: DataSourceFlag;
  @Input() xapoMode: boolean;
  @Input() module: string;
  @Input() adminMode: boolean;
  @Input() apoType: string;

  @Output() primaryRecordChanged = new EventEmitter<AddressModel>();
  @Output() recordEditClicked = new EventEmitter<AddressModel>();
  @Output() recordDeleted = new EventEmitter<AddressModel>();
  @Output() suggestionsFound = new EventEmitter<ApoSuggestion>();

  suggestionLink: ApoSuggestion;
  validSuggestionLink = false;

  protected destroyActions = new Subject<boolean>();

  constructor(private apoSearchService: APOSearchService) { }

  ngOnInit(): void {
    const refAddr = convertAddressModeltoRefAddressModel(this.address);
    this.apoSearchService.getRelatedAPOfromAddresses([refAddr], this.module)
      .pipe(takeUntil(this.destroyActions))
      .subscribe(res => {
        const suggestionData: ApoSuggestion = {
          source: APOEntityType.Address.toLowerCase(),
          sourceId: this.xapoMode ? refAddr.UID : refAddr.refAddressId?.toString(),
          sourceLabel: getAddressDescription(this.address),
          addresses: res.AddressList.map(address => convertRefAddressModeltoAddressModel(address)),
          parcels: res.ParcelList,
          owners: res.OwnerList
        };
        this.suggestionLink = suggestionData;
        this.validSuggestionLink = (this.suggestionLink?.parcels.length > 0 || this.suggestionLink?.owners.length > 0);
        if (this.apoType === APOEntityType.Address) {
          this.setToSuggestions(event);
        }
      });
  }

  getAddressCardText(): string {
    return getAddressDescription(this.address);
  }

  isPrimary(): boolean{
    return this.address.primaryFlag === FlagEnum.Y;
  }

  setToPrimary(event: Event) {
    if(this.adminMode){
      return;
    }

    this.primaryRecordChanged.emit(this.address);
    event.stopPropagation();
  }

  showViewForm(event: Event){
    if(this.adminMode){
      return;
    }
    this.recordEditClicked.emit(this.address);
  }

  deleteRecord(event: Event) {
    this.recordDeleted.emit(this.address);
    event.stopPropagation();
  }

  getSuggestionTooltip(){
    if(!this.suggestionLink){
      return;
    }
    if(this.suggestionLink.addresses?.length > 0 || this.suggestionLink.owners?.length > 0) {
      const arry = new Array<string>();
      if(this.suggestionLink.parcels?.length > 0){
        arry.push('parcels');
        if(this.suggestionLink.owners?.length > 0){
          arry.push('and');
        }
      }
      if(this.suggestionLink.owners?.length > 0){
        arry.push('owners');
      }
      const msg = arry.join(' ');
      return `This address has multiple associated ${msg}. Click to view and manage`;
    }
  }

  setToSuggestions(event: Event) {
    if (this.validSuggestionLink) {
      this.suggestionLink.addresses = [];
      this.suggestionsFound.emit(this.suggestionLink);
      event.stopPropagation();
    }
  }

  ngOnDestroy(): void {
    this.destroyActions.next();
    this.destroyActions.complete();
  }
}
